import { render, staticRenderFns } from "./newAddress.vue?vue&type=template&id=ce2c7aec"
import script from "./newAddress.vue?vue&type=script&lang=js"
export * from "./newAddress.vue?vue&type=script&lang=js"
import style0 from "./newAddress.vue?vue&type=style&index=0&id=ce2c7aec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports